import { render } from "./ContentPagination.vue?vue&type=template&id=435a319a&scoped=true&ts=true"
import script from "./ContentPagination.vue?vue&type=script&lang=ts"
export * from "./ContentPagination.vue?vue&type=script&lang=ts"

import "./ContentPagination.vue?vue&type=style&index=0&id=435a319a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435a319a"]])

export default __exports__